/* @flow */

export const SUPPORT_RETRIEVE_EMAIL_REQUEST = 'SUPPORT_RETRIEVE_EMAIL_REQUEST';
export const SUPPORT_RETRIEVE_EMAIL_SUCCESS = 'SUPPORT_RETRIEVE_EMAIL_SUCCESS';
export const SUPPORT_RETRIEVE_EMAIL_FAILURE = 'SUPPORT_RETRIEVE_EMAIL_FAILURE';

export const RESET_RETRIEVED_USERNAME = 'RESET_RETRIEVED_USERNAME';
